import React from 'react';
import { useLocation } from 'react-router-dom';

import { TileCarouselResult } from 'api/types/shared.types';
import Box from 'components/Box';
import { LogoImage } from 'components/Image';
import { SearchTileLink } from 'components/Search/SearchTileLink';
import { BodyMicro, H4, H5 } from 'components/Text';
import { colors } from 'theme';
import { trackClicked } from 'utils/analytics';

import { SectionSearchTile } from './SectionSearchTile';
import { TruncatedText } from './TruncatedText';

type SectionProps = {
  result: TileCarouselResult;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/no-unused-prop-types
  headline: string | null | undefined;
  listingType: string;
  carouselLocation?: string;
  fromListingId?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/no-unused-prop-types
  results: Array<TileCarouselResult> | null | undefined;
  layout: 'SLIM' | 'REGULAR';
  source?: string;
  additionalAnalyticsProps?: Record<string, string>;
};
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const Section = ({
  result,
  listingType,
  carouselLocation,
  fromListingId,
  layout,
  source,
  additionalAnalyticsProps,
}: SectionProps) => {
  const reactRouterLocation = useLocation();

  let location = result.city || '';

  if (result.city && result.state) {
    location += ', ';
  }

  if (result.state) {
    location += result.state;
  }

  return (
    <Box m="4px auto" px="4px">
      <SectionSearchTile layout={layout}>
        <SearchTileLink
          location={reactRouterLocation}
          url={result.url}
          trackClick={() => {
            trackClicked('Featured Listing', {
              ...(additionalAnalyticsProps || {}),
              listing_type: listingType,
              from_listing_id: fromListingId || null,
              to_listing_id: result.objectID,
              carousel_location: carouselLocation || null,
              layout,
              source,
            });
          }}
          aria-label={result.name}
        />
        <Box
          display="flex"
          alignItems="flex-start"
          justifyContent="space-between"
          flexDirection="column"
          width="100%"
          height="100%"
          textAlign="left"
          mb="10px"
        >
          {layout === 'REGULAR' && (
            <Box height={120} display="flex" alignItems="center" mb={20}>
              <LogoImage
                justifyContent="flex-start"
                fsWidth={240}
                fsHeight={120}
                alt={result.name}
                handle={result.logo ? result.logo.handle : undefined}
                mimetype={result.logo ? result.logo.mimetype : undefined}
              />
            </Box>
          )}

          <Box width="100%">
            <H5
              width="100%"
              mb={layout === 'REGULAR' ? 4 : 12}
              color={colors.battleshipGrey}
              lineHeight={1.375}
            >
              <Box
                as="span"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                overflow="hidden"
                width="100%"
                display="inline-block"
              >
                {result.orgName}
              </Box>
            </H5>

            <Box maxHeight={86} overflow="hidden">
              <H4 my={0} lineHeight={1.375}>
                <TruncatedText>{result.name}</TruncatedText>
              </H4>
            </Box>
          </Box>

          <BodyMicro color={colors.battleshipGrey}>{location}</BodyMicro>
        </Box>
      </SectionSearchTile>
    </Box>
  );
};
